import NewsAnnouncement from './NewsAnnouncement';
export default NewsAnnouncement;
